import React, { Component } from "react";
import { LogsService } from "app/_services/LogsService/LogsService";
import { chatDateFormat } from "app/_helpers/helper";


class LogHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            submoduleData: []
        }
    }

    componentDidMount() {
        if (this.props.subModulename) {
            this.subModuleData();
        }
    }
    
    componentDidUpdate(prev){
        if(this.props.refrenceId !== prev.refrenceId){
            this.subModuleData();
        }
    }

    async subModuleData() {
        let obj = {
            "submoduleName": this.props.subModulename,
            "projectId": this.props.projectId,
            "refrenceId": this.props.refrenceId
        }
        let response = await LogsService.subModuleData(obj);

        if (response && response.status && response.data) {
            this.setState({
                submoduleData: response.data.submoduleData
            })
        } else {
            this.setState({
                submoduleData: []
            })
        }
    }

    render() {
        const {
            submoduleData
        } = this.state;

        return (
            <React.Fragment>
                {/* <button
                    className="btn btn-secondary"
                    onClick={() => { this.setState({ show: !this.state.show }) }}
                >{this.state.show ? 'Hide' : 'Show'} Log History</button> */}

                {
                    this.state.show ?
                        <div className="card mt-4">
                            <div className="card-body p-0">
                                <div className="simple-card-title m-0">
                                    <h3 class="text-capitalize mb-1">Logs History</h3>
                                </div>
                                <div className="table-responsive logTable" style={{ maxHeight: "300px" }}>
                                    <table className="table table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Action</th>
                                                <th scope="col">Date</th>
                                                <th scope="col">By User</th>
                                                <th scope="col">IP Address</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {submoduleData && submoduleData.length > 0 &&
                                                submoduleData.map((data, index) => {

                                                    return (
                                                        <tr
                                                            key={index}
                                                        >
                                                            <th>{index + 1}</th>
                                                            <td><span className="badge badge-pill badge-danger">{data.action}</span></td>
                                                            <td>{data ? chatDateFormat(data.createdAt) : ''}</td>
                                                            <td>{data && data.user ? data.user.firstName : ''}</td>
                                                            <td>{data && data.ipAddress ? data.ipAddress : ''}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            {/* <tr>
                                    <th>2</th>
                                    <td><span className="badge badge-pill badge-success">Approve</span></td>
                                    <td>2020-09-04 01:30:20</td>
                                    <td>Shubham</td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <td><span className="badge badge-pill badge-secondary">Modify</span></td>
                                    <td>2020-09-04 01:30:20</td>
                                    <td>Vishal Kumar</td>
                                </tr>
                                <tr>
                                    <th>4</th>
                                    <td><span className="badge badge-pill badge-primary">Create</span></td>
                                    <td>2020-09-04 01:30:20</td>
                                    <td>Sudhir Yadav</td>
                                </tr> */}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        : null
                }
            </React.Fragment>
        );
    }
}

export default LogHistory;
